import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from "lodash";
import { ToastService } from 'ng-uikit-pro-standard';
import { PagoService } from 'src/app/services/pago.service';
import { ProveedorService } from 'src/app/services/proveedor.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { RutService } from './../../../../../shared/services/rut.service';

@Component({
  selector: 'app-cc-proveedor-pagos-listas',
  templateUrl: './cc-proveedor-pagos-listas.component.html',
  styleUrls: ['./cc-proveedor-pagos-listas.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class CcProveedorPagosListasComponent implements OnInit {

  @Input() rutProveedorSel = 0;
  public enabled:boolean=true;
  listaDeuda: any;
  listaTotales= {
    total_abono:0,
    total_deuda:0,
    total_monto:0,
    total_pago:0
  };
  listaTotalesCanje = {
    total_abono:0,
    total_deuda:0,
    total_monto:0,
    total_pago:0
  }
  listaCanje:any = null;

  totalConforme=0;

  public habilitaConforme:boolean=false;

  public nombreProveedorSel;
  public rutUsuario;
  rutEmpresa: number;
  sucursalEmpresa: number;
  paginaActual: number;
  @Output() eventoConformePago = new EventEmitter();


  constructor(
    private proveedorDeudaService: ProveedorService,
    private pagoService: PagoService,
    private accesolocalstorage: SecurityService,
    private toastService: ToastService,
    private rutService : RutService
  ) { }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
  }

  checkDoctoPendiente(data){
    console.log("muestrame deuda" , data)

    if (data.seleccion){
        data.abono = data.saldo;
      }
      else{
        data.abono =0;
      }
    this.sumaConforme();
  }

  checkAllDoctoPendiente(){
    this.listaDeuda.forEach(element => {
      element.seleccion=!element.seleccion;
      if (element.seleccion){
        element.abono = element.monto;
      }
      else{
        element.abono =0;
      }
    });
    console.log('LISTA DEUDA', this.listaDeuda)
    this.loadPagosProveedorTotales();
    this.sumaConforme();
  }

  checkAllDoctoCanje(){
    if(this.listaCanje){
      this.listaCanje.forEach(element => {
        element.seleccion=!element.seleccion;
      });
      this.sumaConforme();
      this.loadPagosProveedorTotalesCanje();
    }
    
    console.log('checkAllDoctoCanje', this.listaCanje);
  }

  sumaConforme() {
    const inputParams = this.getInputParamsConformeProveedor();

    const {saldoDocumento, canjeDocumento} = inputParams.entidad;

    if (
      saldoDocumento.length === 0 &&
      canjeDocumento.length === 0
    ) {
      this.totalConforme = 0;
      this.listaTotales.total_abono = 0;
      this.listaTotalesCanje.total_abono = 0;
      return;
    }

    this.pagoService.obtenerTotalConformeProveedor(inputParams, ({mensajes, respuesta}) => {
      if (mensajes && mensajes.length > 0 && mensajes.some(m => m.tipo === TipoMensaje.ERROR)) {
        mensajes.forEach((m) =>{
          if (m.tipo === TipoMensaje.ERROR) {
            this.toastService.error(m.texto || 'No se pudo calcular el total conforme')
          }
        });
        return;
      }

      console.log('TOTALES', respuesta)
      this.listaTotales.total_abono = respuesta.total_pago_cuenta;
      this.listaTotalesCanje.total_abono = respuesta.total_pago_cuenta_utilizado;
      this.totalConforme = respuesta.diferencial_pagar;

      this.formatearAbonosSeleccionados();
    })
  }


  // sumaConforme(){
  //   // const tot = this.listaDeuda.reduce((acumulador, current)=> {
  //   //   return Number(acumulador) + Number(current.abono);
  //   // }, 0);

  //   // this.totalConforme= tot - this.listaTotalesCanje.total_abono;
  //    this.listaDeuda.forEach(deu => {
  //     // console.log("muestrame el abono ",deu.abono);
  //     if(deu.abono > 0){
  //       deu.abono = deu.abono.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  //     }
  //    })

  //   const datos = this.listaDeuda.map(x => {
  //     const params = {
  //       total_abono: Number(x.abono.toString().replace(/\./g, '')),
  //     }
  //     return params;
  //   })

  //   this.listaTotales.total_abono = _.sumBy(datos, 'total_abono')
  //   //  console.log("la suma es",this.listaTotales.total_abono)

  //   this.totalConforme = this.listaTotales.total_abono - this.listaTotalesCanje.total_abono
  // }

  checkDoctoCanje(){
    this.loadPagosProveedorTotalesCanje();
  }

  loadPagosProveedorTotalesCanje(){
    this.proveedorDeudaService.getObtenerDocumentosCanjeTotales(this.listaCanje, ({ mensajes, respuesta}) => {
      if ((respuesta === null) || (respuesta==undefined))
      {
        this.toastService.warning("No se encuentran registros");
      }
      else
      {
        this.listaTotalesCanje = respuesta;
      }
      this.sumaConforme();

    } );
  }

  loadDocumentosCanjeProveedor(){
    this.proveedorDeudaService.getObtenerDocumentosCanjeProveedor(this.rutService.QuitarDV(this.rutProveedorSel), this.sucursalEmpresa, this.rutEmpresa, 1, -1, ({mensajes, respuesta}) => {
      if ((respuesta === null) || (respuesta === undefined)){
        if (mensajes.length>0){
          this.toastService.info(mensajes[0].texto);
        }
        this.listaCanje= null;
      }
      else{
        if (mensajes.length>0){
          this.toastService.info(mensajes[0].texto);
        }
        else
        {
          this.listaCanje = respuesta.registros;
        }
        this.loadPagosProveedorTotalesCanje();
      }

    });
  }

  loadPagosProveedor(rutSel:any){
    this.rutProveedorSel=this.rutService.QuitarDV(rutSel);
    this.proveedorDeudaService.getObtenerDeudaProveedor(this.rutEmpresa, this.sucursalEmpresa, this.rutProveedorSel, this.paginaActual, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      if (registros.count<0){
        this.toastService.warning("No se encontraron registros");
      }
      this.listaDeuda = registros;
      this.listaDeuda.forEach(element => {
        element.abono =  Number(element.abono.toString().replace(/\./g, ''));
      })

      this.loadPagosProveedorTotales();
      this.loadDocumentosCanjeProveedor();
    });
  }


  validateConforme():boolean{
    //Validar si hay alguno seleccionado
    let haySeleccion=false;
    let hayMonto=false;
    this.listaDeuda.forEach(element => {
      if (element.seleccion)
      {
        haySeleccion=true;
        if (element.abono===0){
            hayMonto=false;

        }else{
          hayMonto=true;
        }

      }
    });

    if (!haySeleccion){
      this.toastService.warning('Debe seleccionar algún documento', 'Falta información');
      return false;
    }
    else{
      if (!hayMonto){
        this.toastService.warning('Si selecciona un documento, debe ingresar el monto a pagar');
        return false;
      }

    }

    if (this.totalConforme <= 0) {
      this.toastService.warning('El monto a pagar debe ser mayor a 0');
      return false;
    }

    return true;
}

  enviaConforme()
  {
    if (!this.validateConforme())
    {
      return;
    }
    this.enabled=false;

    this.listaDeuda.forEach(element => {
      element.abono =  Number(element.abono.toString().replace(/\./g, ''));
    })

    console.log("Envio conforme ", this.listaDeuda);

    this.proveedorDeudaService.setConforme(this.listaDeuda, ({ mensajes, respuesta }) => {

      if (mensajes.length>0){
        mensajes.forEach(element => {
          if (element.tipo==="ERROR"){
            this.toastService.error(element.texto);
          }
          else{
            this.toastService.warning(element.texto);
          }
        });
      }
      else{
        const { saldoDocumento } = respuesta;

        if (saldoDocumento.count<0){
          this.toastService.warning("No se encontraron registros");
        }
        else{
          this.loadPagosProveedorTotales();
          this.eventoConformePago.emit(this.totalConforme);

          // this.bloqueaDoctos();
        }
      }



    });
  }

  loadPagosProveedorTotales(){
    this.proveedorDeudaService.getObtenerDeudaProveedorTotales(this.listaDeuda, ({ mensajes, respuesta}) => {
      if ((respuesta === null) || (respuesta==undefined))
      {
        this.toastService.warning("No se encuentran registros");
      }
      else
      {
        this.listaTotales = respuesta;
        console.log("muestrame totales ", this.listaTotales);
      }
    } );
  }

  // limpiarFiltro(){
  //   this.totalConforme = 0;
  // }

  limpiar(): void {
    this.enabled = true;
    this.listaDeuda = [];
    this.listaCanje = [];
    this.listaTotales = {
      total_abono: 0,
      total_deuda: 0,
      total_monto: 0,
      total_pago: 0,
    };
    this.listaTotalesCanje = {
      total_abono: 0,
      total_deuda: 0,
      total_monto: 0,
      total_pago: 0,
    };
    this.totalConforme = 0;
    this.habilitaConforme = false;
  }

  private getInputParamsConformeProveedor() {
    const saldoDocumento = (this.listaDeuda ? _.cloneDeep(this.listaDeuda) : [])
      .filter((doc) => doc.seleccion)
      .map((doc) => {
        delete doc.__typename;
        doc.abono = Number(doc.abono.toString().replace(/\./g, ''));
        return doc;
      });

    const canjeDocumento = (this.listaCanje ? _.cloneDeep(this.listaCanje) : [])
      .filter((doc) => doc.seleccion)
      .map((doc) => {
        delete doc.__typename;
        doc.abono = doc.abono
          ? Number(doc.abono.toString().replace(/\./g, ''))
          : Number(doc.monto.toString().replace(/\./g, ''));
        return doc;
      });

    return {
      entidad: {
        saldoDocumento: saldoDocumento ? saldoDocumento : [],
        canjeDocumento: canjeDocumento ? canjeDocumento : [],
      },
    };
  }

  private formatearAbonosSeleccionados() {
    if (!this.listaDeuda) {
      return;
    }

    this.listaDeuda.forEach((doc) => {
      doc.abono = doc.abono.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      // if (doc.abono > 0) {
      // }
    });
  }
}
